

















import { Component, Mixins } from 'vue-property-decorator';
import Layout from '@/layouts/Layout';
import ContentBlocks from '@/components/content/ContentBlocks.vue';
import Hero from '@/components/Hero.vue';
import CmsContentMixin from '@/mixins/CmsContentMixin';

@Component({
  components: { Layout, ContentBlocks, Hero },
})
export default class ContentPage extends Mixins(CmsContentMixin) {
  layout = 'LayoutDefault';

  async mounted() {
    this.fetchContent();
  }
}
